import { render } from "./NewBasketUpsells.vue?vue&type=template&id=dd8879c8&scoped=true"
import script from "./NewBasketUpsells.vue?vue&type=script&lang=js"
export * from "./NewBasketUpsells.vue?vue&type=script&lang=js"

import "./NewBasketUpsells.vue?vue&type=style&index=0&id=dd8879c8&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8879c8"]])

export default __exports__